import urlFieldValidate from "@validators/shared/url.validate";

export type TErrors = {
  mediaUrl: string | undefined;
};

const awardVideoValidate = (FormValues: Record<string, any>) => {
  let errors: TErrors = {
    mediaUrl: undefined,
  };

  errors.mediaUrl =
    typeof FormValues.mediaUrl === "string"
      ? urlFieldValidate(FormValues.mediaUrl, "Video")
      : undefined;

  return errors;
};

export default awardVideoValidate;
